import React from 'react';
/* eslint-disable-next-line import/no-extraneous-dependencies */
import MuiForm from 'rjsf-material-ui';

/* eslint-disable react/prop-types */
const withJsonSchema = (WrapComponent) => ({
  options, registry: { widgets, fields }, ...rest
}) => {
  const { children, ...otherProps } = options;
  const renderChildren = () => {
    if (!children) return null;
    if (Array.isArray(children)) {
      return children.map((child) => (
        <MuiForm {...child} widgets={widgets} fields={fields}>
          <div />
        </MuiForm>
      ));
    }
    if (React.isValidElement(children)) {
      return children;
    }

    return (
      <MuiForm {...children} widgets={widgets} fields={fields}>
        <div />
      </MuiForm>
    );
  };

  return (
    <WrapComponent {...otherProps} {...rest}>
      {renderChildren()}
    </WrapComponent>
  );
};
/* eslint-enable react/prop-types */

export default withJsonSchema;
